import { Box, BoxProps } from "@mui/material"
import InfiLoader from "./InfiLoader"
import GLoader from "./GLoader"
import styles from './Loader.module.css'

type TLoader = {
  loading: boolean
  size?: number
  type: "InfiLoader" | "GLoader" | 'simple'
}

const Loader = (props: TLoader & BoxProps) => {
  const { loading, type, ...boxProps } = props

  if (!loading) return <></>

  if (type === "InfiLoader") return <InfiLoader {...boxProps} />
  else if (type === "GLoader") return <GLoader {...boxProps} />
  else return <div style={{height: props?.size || 20, width: props?.size || 20}} className={`${styles.spinner}`}></div>
}

export default Loader
